import { useEffect } from 'react';
import { useLocation } from 'react-router';

import { useHost } from 'contexts/Host';
import { requestHostNavigation } from 'utils/browserUtil';

/** Reports every portal route change to the Wealth Navigator, redirects included. */
export function useHostRouteSync() {
  const location = useLocation();
  const { isWena } = useHost();

  useEffect(() => {
    if (!isWena) return;

    requestHostNavigation(location.pathname, location.search);
  }, [isWena, location.pathname, location.search]);
}
